import { useTranslation } from 'react-i18next'

import { EmailAccountSelectField } from '../EmailAccountSelectField'
import {
  EMAIL_CREATION_FORM_ACCOUNT_API_PARAMS,
  EMAIL_CREATION_FORM_FIELD_NAME_REPLY_TO,
} from '../EmailCreationForm.constants'

function ReplyToField() {
  const { t } = useTranslation()

  return (
    <EmailAccountSelectField
      apiParams={EMAIL_CREATION_FORM_ACCOUNT_API_PARAMS}
      label={`${t('Email.ReplyToLabelKey')}:`}
      name={EMAIL_CREATION_FORM_FIELD_NAME_REPLY_TO}
      placeholder={t('Email.ReplyToPlaceholderKey')}
    />
  )
}

export default ReplyToField
